import styled from "styled-components";
import imgDesktop from "../../../../assets/icons/mp-img.svg";
import { ReactComponent as ImgDesktopSVG } from "../../../../assets/icons/mp-img.svg";
import { ReactComponent as ImgMobileSVG } from "../../../../assets/icons/about-us.svg";

import imgMobile from "../../../../assets/icons/about-us.svg";
import thick from "../../../../assets/icons/thick.svg";
import { StyledButton } from "../../../../components/Button/button";
import { theme } from "../../../../helpers/theme";
import { Container, MpImg } from "./comonStyles";
import {
  Separator,
  ServicesContianer,
  ServicesHeader,
  ServicesHeaderContainer,
  ServicesList,
  ServicesListItem,
  ServicesSubHeader,
  ServicesListItemIcon,
  ServicesListItemTextContainer,
  ServicesListItemHeader,
  ServicesListItemText,
} from "./itemListStyles";
import Icon from "../../../../components/icon";
import { useNavigate } from "react-router-dom";

const OurServices = () => {
  const navigate = useNavigate();
  return (
    <>
      <Container>
        <MpImgContainer>
          <Icon width="100%" height="100%" icon={<ImgDesktopSVG />} />
          {/* <MpImg src={imgDesktop} /> */}
        </MpImgContainer>

        <FillFormSection>
          <img style={{ width: "100%", height: "100%" }} src={imgMobile} />
          <FillFormSectionDescription>
            Wypełnij formularz i otrzymaj najlepszą ofertę magazynowania
          </FillFormSectionDescription>
          <StyledButton
            variant="contained"
            sx={{
              position: "absolute",
              top: "78%",
              left: "4%",
            }}
            onClick={() => navigate("/offer-form")}
          >
            Wypełnij formularz
          </StyledButton>
        </FillFormSection>
        <ServicesContianer>
          <ServicesHeaderContainer>
            <ServicesHeader>Nasze usługi</ServicesHeader>
            <ServicesSubHeader>
            Dostosowane do Twoich potrzeb i oparte na najnowszych rozwiązaniach logistycznych. 
            </ServicesSubHeader>
          </ServicesHeaderContainer>
          <Separator />
          <ServicesList>
            <ServicesListItem>
              <ServicesListItemIcon src={thick} />
              <ServicesListItemTextContainer>
                <ServicesListItemHeader>Składowanie</ServicesListItemHeader>
                <ServicesListItemText>
                Nasze magazyny zapewniają bezpieczne i elastyczne miejsce na Twoje produkty.
                </ServicesListItemText>
              </ServicesListItemTextContainer>
            </ServicesListItem>
            <Separator />
            <ServicesListItem>
              <ServicesListItemIcon src={thick} />
              <ServicesListItemTextContainer>
                <ServicesListItemHeader>Crossdocking</ServicesListItemHeader>
                <ServicesListItemText>
                Szybkie i dokładne przygotowanie towarów do dalszej dystrybucji. 
                </ServicesListItemText>
              </ServicesListItemTextContainer>
            </ServicesListItem>
            <Separator />
            <ServicesListItem>
              <ServicesListItemIcon src={thick} />
              <ServicesListItemTextContainer>
                <ServicesListItemHeader>Fullfilment</ServicesListItemHeader>
                <ServicesListItemText>
                Sprawna obsługa zamówień i dostawa produktów do klientów, z dbałością o terminowość i bezpieczeństwo.
                </ServicesListItemText>
              </ServicesListItemTextContainer>
            </ServicesListItem>
            <Separator />
          </ServicesList>
        </ServicesContianer>
      </Container>
    </>
  );
};

export default OurServices;
const MpImgContainer = styled.div`
  @media (max-width: 1024px) {
    display: none;
  }
  width: 250px;
  height: 250px;
  margin-bottom: 50px;
  margin-top: 20px;

  @media ${theme.device.mobileL} {
    width: 300px;
    height: 300px;
  }

  @media ${theme.device.tablet} {
    width: 430px;
    height: 430px;
  }

  @media ${theme.device.laptopL} {
    width: 530px;
    height: 530px;
  }
`;

const FillFormSection = styled.div`
  @media (min-width: 1025px) {
    display: none;
  }
  position: relative;
  width: 300px;
  height: 300px;
  margin-bottom: 50px;
  margin-top: 20px;

  @media ${theme.device.tablet} {
    width: 400px;
    height: 400px;
  }
`;
const FillFormSectionDescription = styled.span`
  font-family: ${theme.fonts.interMedium};
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  top: 60%;
  left: 5%;
  color: white;
  position: absolute;
  margin-left: 2px;
  @media ${theme.device.tablet} {
    top: 60%;
    left: 5%;
    font-size: 24px;
    line-height: 30px;
  }
`;
